export const SET_USER_TOKEN = 'SET_USER_TOKEN'


// WEBPACK FOOTER //
// ./src/type.js